// extracted by mini-css-extract-plugin
export default {"offlineRibon":"AppShell-offlineRibon-eKN"};